module.exports = __webpack_public_path__ + "image/pro_icon8.png";